import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";

// Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Books from "./components/Books";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import NewsletterPopup from "./components/NewsletterPopup";
import { Toaster } from "./components/ui/toaster";

// SEO Meta Component
const SEOHead = () => {
  useEffect(() => {
    // Set page title
    document.title = "Luisa Landre - Autora de romances";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", 
        "Luisa Landre é autora brasileira de comédias românticas, literatura sáfica e ficção especulativa. Autora de Feras em Campo, Noturnas e Natalinas, Fios de Sangue e As Novas Românticas."
      );
    }

    // Set meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute("content", 
        "Luisa Landre, escritora sáfica, romance sáfico, fantasia urbana, vampiros, lobisomens, literatura brasileira, autora brasileira, Feras em Campo, Noturnas e Natalinas, Fios de Sangue, As Novas Românticas, livros LGBT, representatividade"
      );
    }
  }, []);

  return null;
};

const Home = () => {
  return (
    <div className="min-h-screen">
      <SEOHead />
      <Header />
      <main>
        <Hero />
        <About />
        <Books />
        <Contact />
      </main>
      <Footer />
      <NewsletterPopup />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;